<template>
  <section class="dp-layout">
    <section class="dp-right">
    <!--工具条-->
    <toolbar :buttonList="buttonList" :groupThreshold="4" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <div class="tbl-scroll-host">
    <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
      style="width: 100%" class="custom-tbl" height="100%">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="CardId" label="卡号" width></el-table-column>
      <!-- <el-table-column prop="Imei" label="IMEI码" width></el-table-column> -->
      <el-table-column prop="IsUse" label="是否在用" width>
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsUse ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsUse ? "是" :
            "否" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="UseTime" label="使用时间" width></el-table-column>
      <el-table-column prop="Name" label="姓名" width></el-table-column>
      <!-- <el-table-column prop="Role" label="角色" width></el-table-column> -->
      <el-table-column prop="SchId" label="机构标识" width></el-table-column>
      <el-table-column prop="CreateTime" label="入库时间" width></el-table-column>
      <el-table-column prop="ModifyTime" label="修改时间" width></el-table-column>
    </el-table>
    </div>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
        style="float: right"></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">

        <el-form-item label="卡号" prop="CardId">
          <el-input v-model="editForm.CardId" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="IMEI" prop="Imei">
          <el-input v-model="editForm.Imei" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="状态" prop="IsUse">
          <el-select v-model="editForm.IsUse" label="状态" prop="IsUse" placeholder="请选择卡号状态">
            <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">

        <el-form-item label="卡号" prop="CardId">
          <el-input v-model="addForm.CardId" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="IMEI" prop="Imei">
          <el-input v-model="addForm.Imei" auto-complete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!-- 导入 -->
    <input type="file" ref="upload" accept=".xls,.xlsx" class="outputlist_upload" style="display: none"
      v-if="excelInput" @input="readExcel" />
    <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="40%" title="导入信息核对">
      <el-table :data="outputs" ref="outputs_table" align="center" style="width: 100%">
        <el-table-column prop="Card" label="卡号" width></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width>
          <template slot-scope="scope">
            <span style="color: red; cursor: pointer" @click="removeImport(scope)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="excelShow = false">取 消</el-button>
        <el-button type="primary" @click="SavaImport">确认导入</el-button>
      </span>
    </el-dialog>

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getCardInfoListPage, removeCardInfo, editCardInfo, addCardInfo, importCardList } from '../../api/modules/personnel';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
// excel 读取
import { read, utils } from 'xlsx'

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: "",
      },
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "是", value: true },
        { name: "否", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CardId: [{ required: true, message: "请输入卡号", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CardId: "",
        Imei: "",
        IsUse: false
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CardId: [{ required: true, message: "请输入卡号", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CardId: "",
        Imei: "",
        IsUse: false,
      },
      isResouceShow: 0,

      //excel
      outputs: [],
      excelInput: true, //input渲染状态
      excelShow: false,
    };
  },
  computed: {

  },
  methods: {
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;
      //NProgress.start();
      getCardInfoListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeCardInfo(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }

      // 按顶部固定学校加载教学树，避免总平台/其他学校。最后更新：2026-08-29
      const schoolId = this.$store.state.activeSchoolId
        || window.localStorage.getItem('activeSchoolId');
      if (!schoolId || Number(schoolId) <= 0) {
        this.$message.warning("请先选择学校");
        return;
      }
      let para = { pid: 0, scopeDepartmentId: schoolId };
      getTeachingDepartmentTree(para).then((res) => {
        ++this.isResouceShow;
        const root = res.data && res.data.response;
        this.options = root ? [root] : [];
        setTimeout(() => {
          if (this.$refs.treeEdit) {
            this.$refs.treeEdit.setCheckedKeys(row.Dids.split(","));
          }
        }, 100);
      });

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      // 按顶部固定学校加载教学树，避免总平台/其他学校。最后更新：2026-08-29
      const schoolId = this.$store.state.activeSchoolId
        || window.localStorage.getItem('activeSchoolId');
      if (!schoolId || Number(schoolId) <= 0) {
        this.$message.warning("请先选择学校");
        return;
      }
      this.addFormVisible = true;
      this.options = [];
      this.addForm = {
        CardId: "",
        Imei: "",
        IsUse: false,
      };

      let para = { pid: 0, scopeDepartmentId: schoolId };
      getTeachingDepartmentTree(para).then((res) => {
        ++this.isResouceShow;
        const root = res.data && res.data.response;
        this.options = root ? [root] : [];
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            // para.ModifyTime = util.formatDate.format(
            //   new Date(),
            //   "yyyy-MM-dd hh:mm:ss"
            // );

            editCardInfo(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            addCardInfo(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach((element) => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },

    // 导入
    // 调起导入信息
    ImportCensus() {
      this.$refs.upload.click()
    },

    //删除错误行
    removeImport(e) {
      console.log(e['$index'])
      this.$confirm('确定要删除' + e.row.Card + '的信息').then(() => {
        this.outputs.splice(e['$index'], 1)
      })
    },
    // 保存信息
    SavaImport() {
      const loading = this.$loading({
        lock: true,
        text: '导入中',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      console.log('确认导入', JSON.stringify(this.outputs))

      importCardList(this.outputs)
        .then((res) => {
          if (res.data.success) {
            loading.close()
            this.$message({
              message: res.data.msg,
              type: 'success',
              duration: 0,
              showClose: true
            })
            this.excelShow = false
          } else {
            loading.close()
            this.$message({
              message: res.data.msg,
              type: 'error',
              duration: 0,
              showClose: true
            })
          }
        })
        .catch((e) => {
          loading.close()
          this.$message({
            message: '导入失败',
            type: 'error',
          })
        })
    },
    readExcel(e) {
      var that = this
      const files = e.target.files
      // 如果没有文件名
      if (files.length <= 0) {
        return false
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error('上传格式不正确,请上传xls或者xlsx格式')
        return false
      }

      const loading = this.$loading({
        lock: true,
        text: '正在读取文件',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          // 切换为新的调用方式
          const workbook = read(data, {
            type: 'binary',
          })
          // 取第一张表
          const wsname = workbook.SheetNames[0]
          // 切换为新的调用方式 生成json表格内容
          const ws = utils.sheet_to_json(workbook.Sheets[wsname])
          console.log(ws)
          // 后续为自己对ws数据的处理
          loading.close()
          this.outputs = this.reSetKey(ws)
          this.$nextTick(() => {
            this.excelShow = true
            // 清空input选择的文件
            this.$refs.upload.value = ''
          })
        } catch (e) {
          console.log(e)
          loading.close()
          this.$message.error('文件读取失败')
          return false
        }
      }
      fileReader.readAsBinaryString(files[0])
    },
    reSetKey(ws) {
      let temp = []
      ws.forEach((item) => {
        temp.push({
          Card: item['卡号'] || ''
        })
      })
      return temp
    },

  },
  mounted() {
    this.handleQuery();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
